import { CITY } from '@city'

/**
 * Base URL for online routing (`POST /api/v2/routes`, the city server of
 * the city this build is for — `CITY.apiOrigin`). The client appends `/api/v2/routes` to whatever this resolves
 * to, so the value must NOT include the API prefix.
 *
 *   - Default (every build, incl. local `npm run dev`): the city's
 *     production host, e.g. `https://london-tube.com` (nginx routes
 *     /api/v2/* to the city server on :8010). There is no staging
 *     environment (cancelled studio-wide 2026-10-30), so local testing
 *     talks to prod (TASK-412 #2).
 *
 * Override via `VITE_ROUTING_BASE_URL` — e.g. point a local dev build at a
 * locally-running city server: `VITE_ROUTING_BASE_URL=http://localhost:8010`
 * (mirrors the iOS DEBUG override). The legacy `VITE_API_BASE_URL` may
 * include a trailing `/api/v1` or `/api/v2`; we strip it so either value
 * works in `.env.local`.
 */
function _resolveRoutingBaseURL(): string {
  const explicit = import.meta.env.VITE_ROUTING_BASE_URL
  if (typeof explicit === 'string' && explicit.length > 0) return explicit.replace(/\/$/, '')
  const apiBase = import.meta.env.VITE_API_BASE_URL
  if (typeof apiBase === 'string' && apiBase.length > 0) {
    return apiBase.replace(/\/?api\/v[12]\/?$/, '').replace(/\/$/, '')
  }
  return CITY.apiOrigin
}

export const ROUTING_BASE_URL: string = _resolveRoutingBaseURL()
